import React, { useEffect, useState } from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle, faPlus } from "@fortawesome/free-solid-svg-icons";
// hooks
import useAuth from "../../hooks/useAuth";
// redux
import { useDispatch, useSelector } from "../../redux/store";
import { resetLoading, getAddress } from "../../redux/slices/Customer";
import Page from "../../components/Page";

import "../on-boarding/supplier/SupplierOnboarding.css";
import CustomerAddresses from "./CustomerAddresses";
import AddSupplierLocation from "../../components/_product/Modal/AddSupplierLocation";
import "./Alert.css";

//------------------------------------------------------

const CustomerBasicInfo = () => {
  const { user } = useAuth();
  const dispatch = useDispatch();
  const [showBilling, setShowBilling] = useState(false);
  const [showShipping, setShowShipping] = useState(false);
  const [warning, setWarning] = useState(false);
  const { Address } = useSelector((state) => state.customer);
  const { isLocationSaved } = useSelector((state) => state.user);
  
  useEffect(() => {
    dispatch(getAddress({ user_id: user.id }));
    dispatch(resetLoading());
  }, [dispatch, isLocationSaved]);

  const hideModal = () => {
    setShowShipping(false);
    setShowBilling(false);
  };

  const hanldeAddBillingOpen = () => {
    setShowBilling(true);
  };

  const handleWarning = () => {
    setWarning(false);
  };

  const hanldeAddShippingOpen = () => {
    setShowShipping(true);
  };

  return (
    <Page title="Address">
      {warning && (
        <div className="alert warning">
          <span className="closebtn" onClick={handleWarning}>
            &times;
          </span>
          <strong>Warning!</strong> If you want to delete default address then please choose/add another address as default. Then you can delete that address
        </div>
      )}
        <div className="d-lg-flex justify-content-between align-items-center">
          <h4 className="mb-lg-0 mb-3">Shipping Address</h4>
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => hanldeAddShippingOpen("shipping")}
            title="Add"
          >
            <FontAwesomeIcon icon={faPlus} /> Add New Address
          </button>
        </div>
        <hr />
      {Address !== null &&
      Address !== undefined &&
      Address.shippingAddresses !== null &&
      Address.shippingAddresses !== undefined ? (
        <>
          <div className="row">
            {Address?.shippingAddresses?.length > 0 ? (
              <CustomerAddresses
                locationType="shipping"
                name={user}
                addresses={Address?.shippingAddresses}
                userId={user.id}
                hideModal={hideModal}
                warning={setWarning}
              />
            ) : (
              <span>No record found for shipping address</span>
            )}
          </div>
        </>
      ) : (
        <span>No record found for shipping address</span>
      )}
        <div className="d-lg-flex justify-content-between align-items-center mt-4">
          <h4 className="mb-lg-0 mb-3">Billing Address </h4>
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => hanldeAddBillingOpen("billing")}
            title="Add"
          >
            <FontAwesomeIcon icon={faPlus} /> Add New Address
          </button>
        </div>
        <hr />
      {Address !== null &&
      Address !== undefined &&
      Address.billingAddresses !== null &&
      Address.billingAddresses !== undefined ? (
        <>
          <div className="row">
            {Address?.billingAddresses?.length > 0 ? (
              <CustomerAddresses
                locationType="billing"
                name={user}
                addresses={Address.billingAddresses}
                userId={user.id}
                hideModal={hideModal}
                warning={setWarning}
              />
            ) : (
              <span>No record found for billing address</span>
            )}
          </div>
        </>
      ) : (
        <span>No record found for billing address</span>
      )}
      {showShipping && (
      <AddSupplierLocation
        locationType="shipping"
        handleClose={hideModal}
        locationDetails=""
      />
    )}
    {showBilling && (
      <AddSupplierLocation
        locationType="billing"
        handleClose={hideModal}
        locationDetails=""
      />
    )}
    </Page>
  );
};

export default React.memo(CustomerBasicInfo);